import "./insWaterfallDatapointChart.scss";
import hcMore from "highcharts/highcharts-more";
import Highcharts, { Chart, wrap } from "highcharts/highstock";
import React, { useEffect, useRef } from "react";
import { ManageScroll } from "../insHorizontalBarChart/ins-horizontal-bar-chart-scrolling";
import { useCalculateDesign } from "../insHorizontalBarChart/ins-horizontal-bar-datapoint-chart-helper";
import { InsHighcharts } from "components/widgets/base/insHighcharts";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
hcMore(Highcharts);
wrap(Chart.prototype, "render", ManageScroll);
export const InsWaterfallDatapointBaseChart = ({ widgetFactoryProps, configs, onChartReady }) => {
    const chartContainerRef = useRef(null), chartRef = useRef(null);
    useCalculateDesign({ chartContainerRef,
        chartRef,
        data: configs.series,
        dataLabelsEnabled: configs.inverted,
        displayValueType: configs.displayValueType,
        noDefineLabel: !configs.inverted,
        options: configs.options,
        preformatted: false,
        valueFormat: configs.valueFormat });
    useEffect(() => {
        onChartReady?.(chartRef.current);
    }, [onChartReady]);
    return React.createElement(InsQueryStatedElement, { widgetFactoryProps: widgetFactoryProps, queryState: configs.queryState, hasData: configs.series.length !== 0 },
        React.createElement(InsHighcharts, { colorSet: configs.colorSet, options: configs.options, ref: chartRef, wrapperRef: chartContainerRef, sectionId: widgetFactoryProps.sectionId, widgetId: widgetFactoryProps.widgetId, isMaximizedOne: widgetFactoryProps.isMaximizedOne }));
};
